import { TReduxActions } from '../../../types/redux';
import { FILTERS_SET_MIN_LAND_AREA_TYPE, FILTERS_SET_MAX_LAND_AREA_TYPE } from '../../../constants/action_types';
import { JsonQuery } from '../../../utils/jsonQuery';
import { defaultState } from './defaultState';
import { IJsonQuery } from '../../../../packages/api-models/common/json_query';

export function setLandAreaReducer(jsonQuery: IJsonQuery = defaultState, action: TReduxActions): IJsonQuery {
  switch (action.type) {
    case FILTERS_SET_MIN_LAND_AREA_TYPE:
      return new JsonQuery(jsonQuery).setMinLandArea(action.minLandArea).getSerializable();

    case FILTERS_SET_MAX_LAND_AREA_TYPE:
      return new JsonQuery(jsonQuery).setMaxLandArea(action.maxLandArea).getSerializable();
  }

  return jsonQuery;
}
